import { Button, ConfigProvider, Tooltip } from "antd";
import styles from '../../index.module.less';
import CompetitionModal from "../detailsModal/Competition";
import { useSetState } from "ahooks";
import { InfoCircleOutlined } from "@ant-design/icons";
import GeneralModal from "@/pages/baseProduct/productMonitor/components/detailsModal/General";

const CardItem = ({data}: {data: Record<string, any>}) => {
  const colorEnums = {
    LOW_PROFIT_MARGIN: '#F59300',
    HIGH_PROFIT_MARGIN: '#00A865',
    NEGATIVE_GROSS_PROFIT: '#EB3723',
    LOW_COST: '#00A865',
    HIGH_COST: '#EB3723',
  }
  const tipEnums = {
    LOW_COST: '标配SKU成本价低于通项项目经理价，且成本差比率超过预警线',
    HIGH_COST: '标配SKU成本价高于通项项目经理价，且成本差比率超过预警线',
  }
  const [state, setState] = useSetState({
    open: false,
  })
  
  const onOpenModal = () => {
    setState({open: true})
  }
  console.log(data)
  
  return <div className={styles.card}>
    <div className={styles.title}>
      <span>
        {data.title}
      </span>
      <Button type={'link'} onClick={() => onOpenModal()}>查看详情</Button>
    </div>
    <div className={styles.typeBox}>
      <div className={styles.totalBox}>
        <p>预警总条数</p>
        <p><span>{data.total || 0}</span>条</p>
      </div>
      <div className={styles.splitLine}/>
      <div style={{display: "flex", justifyContent: "space-between", flexGrow: 1}}>
        {data.type?.map?.(item => <div className={styles.typeItem} key={item.alertType}>
          <p>{item.alertTypeName} {tipEnums[item.alertType] && <ConfigProvider
              theme={{
                components: {
                  Tooltip: {
                    colorTextLightSolid: '#2D2D2E',
                    colorBgSpotlight: '#fff',
                    paddingSM: 24,
                    paddingXS: 12,
                    boxShadow: `0 2.5px 11.67px 2px rgba(0, 0, 0, 0.05),0 6.67px 8.33px 1px rgba(0, 0, 0, 0.06),0 4.17px 4.17px -3px rgba(0, 0, 0, 0.1)`,
                  }
                },
              }}
          >
            <Tooltip title={tipEnums[item.alertType]} >
            <InfoCircleOutlined className={styles.icon} />
          </Tooltip>
          </ConfigProvider>}</p>
          <p><span style={{color: colorEnums[item.alertType]}}>{item.count || 0}</span>条</p>
        </div>)}
        {data.modalType === 'general' && <div style={{minWidth: 42}}/>}
      </div>
    </div>
    {state.open ? (data.modalType === 'general' ? 
      <GeneralModal open={state.open} onClose={() => setState({ open: false })}/> :
      <CompetitionModal open={state.open} onClose={() => setState({ open: false })}/>)
      : null}
  </div>
}

export default CardItem